import { useRealtimeChannel } from '@/hooks/useRealtimeChannel'
import { fetchOverview } from '@/lib/metrics'
import { queryClient } from '@/lib/query'
import { ActivityFeed } from '@/pages/dashboard/components/ActivityFeed'
import { KpiGrid } from '@/pages/dashboard/components/KpiGrid'
import { useQuery } from '@tanstack/react-query'

export function DashboardOverview() {
  const overview = useQuery({
    queryKey: ['admin-metrics-overview'],
    queryFn: () => fetchOverview(),
    staleTime: 60_000
  })

  // Backend pushes a refresh signal each minute; invalidate to pull cached payload
  useRealtimeChannel('admin.dashboard.metrics', (event) => {
    if (event.type === 'metrics.overview.refreshed') {
      queryClient.invalidateQueries({ queryKey: ['admin-metrics-overview'] })
    }
  })

  return (
    <div className="grid gap-4 lg:grid-cols-[1fr_360px]">
      <KpiGrid data={overview.data} isLoading={overview.isLoading} />
      <div className="h-[640px]">
        <ActivityFeed />
      </div>
    </div>
  )
}
